<template lang="pug">
#page_content.contact.page
	Banner(v-bind:item='item_banner', classes='half')
	.container.article
		.row
			.col-md-6
				.info
					img.logo(src='@/assets/images/logo.png')
					.wrapper
						h3 {{ $t('contact_title') }}
						p
							| {{ $t('contact_tel') }}： 02-2633-2000 #8013
							br
							| {{ $t('contact_fax') }}： 02-2630-1895
							br
							| {{ $t('contact_address') }}： {{ $t('footer_address') }}
							br
							| Email：ticff.ptsoffice@gmail.com
							br
							| {{ $t('contact_url') }}： www.ticff.org.tw
							br
							| {{ $t('contact_fb_page') }}： https://www.facebook.com/TICFF.tw
			.col-md-6
				iframe(
					src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3613.7591583880735!2d121.60888425056443!3d25.07615088387384!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442acb92ab3a8e9%3A0xfd9ba2225f02abc5!2zMTE05Y-w5YyX5biC5YWn5rmW5Y2A5bq35a-n6Lev5LiJ5q61NzXlt7cxMDDomZ82!5e0!3m2!1szh-TW!2stw!4v1642135789252!5m2!1szh-TW!2stw',
					width='100%',
					height='450',
					style='border: 0',
					allowfullscreen='',
					loading='lazy'
				)
</template>

<script>
import Banner from '@/components/Banner.vue';
export default {
	data() {
		return {
			item_banner: {
				media: 'assets/images/banner_1.jpg',
				title: this.$t('nav_about_contact'),
			},
		};
	},
	watch: {
		'$i18n.locale'() {
			this.item_banner.title = this.$t('nav_about_contact');
		},
	},
	components: {
		Banner,
	},
};
</script>

<style lang="stylus">
#page_content.contact
	.article
		padding: 0
		color: #fff
		text-align: left
		.info
			display: flex
			flex-direction: column
			justify-content: space-between
			height: 100%
			padding: 30px 40px
			line-height: 1.8
			.logo
				width: 50%
			a
				color: $color_yellow

			h3
				margin-bottom: 20px
				line-height: 1.8
		iframe
			margin-bottom: -7px
		@media screen and (max-width: $screen-sm-max)
			.info
				padding: 30px 20px
				.logo
					margin-bottom: 2rem
</style>
